/**
 * StatusBadge Component
 *
 * Semantic workflow status badges with predefined color variants.
 * Use for entity states: Active, Pending, Cancelled, Draft, etc.
 *
 * For categorical/decorative labels (e.g., "Fishing", "Hiking"),
 * use Badge instead.
 *
 * SCRUM-901: StatusBadge & Badge Component Extraction
 *
 * @component
 * @param {Object} props
 * @param {'success'|'warning'|'error'|'info'|'neutral'} props.variant - Semantic variant
 * @param {React.ReactNode} props.children - Badge label text
 * @param {string} [props.className] - Additional classes
 */
import PropTypes from 'prop-types';

const variantClasses = {
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  neutral: 'bg-gray-100 text-gray-800',
};

export default function StatusBadge({ variant = 'neutral', children, className = '' }) {
  const classes = variantClasses[variant] || variantClasses.neutral;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${classes} ${className}`.trim()}
    >
      {children}
    </span>
  );
}

StatusBadge.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
